export default function getScrollPercent() {
  const element = document.documentElement;
  const body = document.body;
  return (
    ((element['scrollTop'] || body['scrollTop']) /
      ((element['scrollHeight'] || body['scrollHeight']) - element.clientHeight)) *
    100
  );
}
